import { Observable } from 'cadenza/utils/event-util';

const ANIMATION_DURATION = 200;

export const HISTORY_UPDATED_EVENT = 'history-updated';

export class NavigationHistory extends Observable {

  constructor (map) {
    super();
    this._map = map;
    this._history = [];
    this._historyPosition = -1;
    this._shouldUpdate = true;
    map.on('moveend', () => this._updateHistory());
  }

  undo () {
    if (this.isUndoEnabled()) {
      this._updateMap(this._history[--this._historyPosition]);
    }
  }

  redo () {
    if (this.isRedoEnabled()) {
      this._updateMap(this._history[++this._historyPosition]);
    }
  }

  _updateMap (state) {
    this._map.getView().animate({
      duration: ANIMATION_DURATION,
      center: state.center,
      zoom: state.zoom,
      rotation: state.rotation
    });
    this._shouldUpdate = false;
  }

  _updateHistory () {
    if (this._shouldUpdate) {
      const view = this._map.getView();
      const state = {
        zoom: view.getZoom(),
        center: view.getCenter(),
        rotation: view.getRotation()
      };

      const stateHasChanged = JSON.stringify(state) !== JSON.stringify(this._history[this._historyPosition]);
      if (stateHasChanged) {
        this._history.splice(++this._historyPosition);
        this._history.push(state);
      }
    } else {
      this._shouldUpdate = true;
    }

    this.dispatchEvent(new CustomEvent(
      HISTORY_UPDATED_EVENT,
      {
        detail: {
          undoEnabled: this.isUndoEnabled(),
          redoEnabled: this.isRedoEnabled()
        }
      }));
  }

  isUndoEnabled () {
    const historyLength = this._history.length;
    return historyLength > 0 && this._historyPosition > 0;
  }

  isRedoEnabled () {
    const historyLength = this._history.length;
    return historyLength > 0 && this._historyPosition < historyLength - 1;
  }

}
